import { LatLngModel } from "@/types/common";
import { Map, MapMouseEvent, Marker } from "@vis.gl/react-google-maps";
import { Circle } from "./Circle";

interface MapProps {
  location?: LatLngModel;
  name?: string;
  onChange?: (name: string, location: LatLngModel) => void;
  radius?: number;
}

const INITIAL_CENTER = { lat: 41.1897, lng: -96.0627 };

export const UserMap = (props: MapProps) => {
  const { location, radius, name, onChange } = props;

  const handleLocationChange = (event: MapMouseEvent) => {
    const region = event.detail.latLng;
    if (onChange && region) {
      onChange(name ?? "location", {
        lat: region.lat,
        lng: region.lng,
      });
    }
  };

  const hasLocation = location && location.lat && location.lng;

  return (
    <div className="w-[400px] h-[400px]">
      <Map
        defaultZoom={20}
        defaultCenter={location}
        zoomControl
        maxZoom={20}
        onClick={handleLocationChange}
      >
        <Marker position={location} />
        {radius && hasLocation && (
          <Circle
            key={(location.lat + location.lng).toString()}
            center={location}
            radius={parseInt(radius.toString()) * 1609.34}
            fillColor="#7a74c3"
            strokeColor="#d3d3d3"
            strokeWeight={5}
          />
        )}
      </Map>
    </div>
  );
};
